import { useMemo } from 'react';
import { useCustomerSession } from '../../shared/session/CustomerSessionProvider.js';
import { useAccountMemberships } from '../account/accountApi.js';
import { useCustomerSurfaceEntitlement } from '../entitlements/customerEntitlementGuards.js';

export interface LoyaltyProfilingAvailability {
  loyaltyProfilingAvailable: boolean;
  isLoading: boolean;
}

export function useLoyaltyProfilingAvailable(): LoyaltyProfilingAvailability {
  const { session, sessionHydrated } = useCustomerSession();
  const isLoggedIn = sessionHydrated && session !== null;
  const memberships = useAccountMemberships(isLoggedIn);
  const surfaceEntitlement = useCustomerSurfaceEntitlement();
  const loyaltyBlock = surfaceEntitlement.isBlockEntitled('loyalty_program');

  return useMemo(() => {
    if (!isLoggedIn) {
      return { loyaltyProfilingAvailable: false, isLoading: false };
    }
    if (memberships.isLoading || surfaceEntitlement.isLoading) {
      return { loyaltyProfilingAvailable: false, isLoading: true };
    }
    const loyaltyProfilingAvailable =
      loyaltyBlock &&
      (memberships.data?.loyalty?.enabled === true ||
        memberships.data?.walletVisible === true);
    return { loyaltyProfilingAvailable, isLoading: false };
  }, [
    isLoggedIn,
    loyaltyBlock,
    memberships.data?.loyalty?.enabled,
    memberships.data?.walletVisible,
    memberships.isLoading,
    surfaceEntitlement.isLoading,
  ]);
}
